var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-btn",
    {
      attrs: {
        block: "",
        color: "success darken-2",
        type: "submit",
        disabled: _vm.disabled,
        loading: _vm.loading,
      },
      on: {
        click: function ($event) {
          return _vm.$emit("nextClick")
        },
      },
    },
    [_vm._v(" " + _vm._s(_vm.title) + " ")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }